<button (click)="buttonClick($event)" class="googleBtn">
    <img class="googleLogo" src="shared-assets/images/googleLogo.png">
    <span class="btnLabel">{{btnLabel}}</span>
</button>
